import tinycolor from 'tinycolor2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from './shadcn/utils'
import { FragmentType, graphql, useFragment } from '../gql'
import { faTag } from '@fortawesome/pro-solid-svg-icons'

const tagVariants = cva('inline-flex items-center justify-center gap-2 font-semibold rounded-lg', {
  variants: {
    size: {
      default: 'text-xs font-semibold px-2 py-1 rounded-lg',
      compact: 'text-sm font-semibold px-2 py-0.5 rounded-lg',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

export const TagComponent_TagFragment = graphql(`
  fragment TagComponent_TagFragment on Tag {
    id
    name
    color
  }
`)

export interface TagProps extends VariantProps<typeof tagVariants> {
  tag: FragmentType<typeof TagComponent_TagFragment>
  className?: string
}

function TagComponent(props: TagProps) {
  const tag = useFragment(TagComponent_TagFragment, props.tag)

  const { size, className } = props
  const isWhite = tinycolor(tag.color).getLuminance() > 0.95

  return (
    <span
      className={cn(tagVariants({ size }), className)}
      style={{
        color: tinycolor(tag.color || '#0058ff').getBrightness() > 170 ? '#000' : '#fff',
        backgroundColor: tag.color || '#0058ff',
        borderWidth: 1,
        borderColor: isWhite ? '#000' : '#fff',
      }}>
      {size !== 'compact' && <FontAwesomeIcon icon={faTag} size="lg" />}
      <span>{tag.name}</span>
    </span>
  )
}

export { TagComponent as Tag }
